import React from 'react'

import { cn } from '@/lib/utils'

interface Props {
  count: number
  size?: 'sm' | 'md' | 'lg'
}

const AvailabilityDot: React.FC<Props> = ({ count, size = 'md' }) => {
  if (count === 0) {
    return <span className="sr-only">Unavailable</span>
  }

  return (
    <span
      className={cn(
        'inline-block rounded-full',
        size === 'sm' ? 'h-2 w-2' : size === 'md' ? 'h-3 w-3' : 'h-4 w-4',
        count <= 2 ? 'bg-warning' : 'bg-success',
      )}
    >
      <span className="sr-only">
        {count} {count === 1 ? 'slot' : 'slots'} available
      </span>
    </span>
  )
}

export default AvailabilityDot
